export default "__VITE_ASSET__BGVqtFeh__"